module.exports = __webpack_public_path__ + "img/tick.84d2d234.svg";